﻿import DefaultApp from './defaultApp';

import EventItem from './components/EventItem.vue';

import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);
import { swiperConfig } from '../vendor/swiper';

const eventApp = {
    ...DefaultApp,
    components: {
        ...DefaultApp.components,
        EventItem,
    },
    data() {
        return {
            ...DefaultApp.data(),
            dataTopicLabel: '',
            dataDateLabel: '',

            swiper: null,
            selectedDate: null,
            isEducation: false,
            skipDateFilter: false,
        };
    },
    computed: {
        ...DefaultApp.computed,
        filtersChosen() {
            return (
                (this.facetsSet && this.data.facets.some((facet) => facet.values.length)) ||
                this.dataOverruleIds.length ||
                this.selectedDate
            );
        },
        filtersActive() {
            return (this.facetsSet && this.data.facets.some((facet) => facet.selected)) || this.selectedDate;
        },
        filterItems() {
            if (this.dataOverruleIds.length) {
                return [
                    {
                        Key: this.constants.filterAliases.id,
                        Values: this.dataOverruleIds,
                        Operator: this.constants.operators.in,
                    },
                ];
            }

            let tempFilterArray = [];

            if (this.selectedDate && !this.skipDateFilter) {
                const excludedStartDate = '0001-01-01T00:00:00';
                const excludedEndDate = '9999-12-31T23:59:59.9999999';

                this.data.items = this.data.items.filter((item) => {
                    return !(item.startDate === excludedStartDate && item.endDate === excludedEndDate);
                });
            }

            if (!this.selectedDate) {
                tempFilterArray.push({
                    Key: this.constants.keys.endDate,
                    Values: [new Date()],
                    Operator: this.constants.operators.greaterThan,
                });
            }
            this.data.facets
                .filter((facet) => facet.values.length && facet.inputType === this.constants.inputTypes.select)
                .forEach((facet) => {
                    let values = facet.values
                        .filter((option) => option && option.valueAlias)
                        .map((option) => option.valueAlias);
                    tempFilterArray.push({
                        Key: facet.alias,
                        Values: values,
                        Operator: this.constants.operators.in,
                    });
                });
            if (this.selectedDate) {
                // Manipulate dates to account for UTC offset and return items which start or end the same day as selectedDate.
                let filterStartDate = new Date(this.selectedDate.setUTCHours(22, 0, 0, 0));
                let filterEndDate = new Date(this.selectedDate.setUTCHours(2, 0, 0, 0));
                tempFilterArray.push(
                    {
                        Key: this.constants.keys.startDate,
                        Values: [filterStartDate],
                        Operator: this.constants.operators.lowerThan,
                    },
                    {
                        Key: this.constants.keys.endDate,
                        Values: [filterEndDate],
                        Operator: this.constants.operators.greaterThan,
                    }
                );
            }
            if (this.ownId) {
                tempFilterArray.push({
                    Key: this.constants.keys.id,
                    Values: [this.ownId],
                    Operator: this.constants.operators.notIn,
                })
            }
            return tempFilterArray;
        },
        selectFacets() {
            if (!this.facetsSet) return [];
            return this.data.facets.filter((facet) => facet.inputType === this.constants.inputTypes.select);
        },
        minDate() {
            if (!this.facetsSet) return null;
            let startDateFacet = this.data.facets.find(
                (facet) => facet.alias === this.constants.filterAliases.startDateString
            );
            if (!startDateFacet.options.length) return null;
            let firstDate = startDateFacet.options.sort((a, b) => new Date(a.valueAlias) - new Date(b.valueAlias))[0]
                .valueAlias;
            return new Date(firstDate);
        },
        maxDate() {
            if (!this.facetsSet) return null;
            let endDateFacet = this.data.facets.find(
                (facet) => facet.alias === this.constants.filterAliases.endDateString
            );
            if (!endDateFacet.options.length) return null;
            let lastDate = endDateFacet.options.sort((a, b) => new Date(b.valueAlias) - new Date(a.valueAlias))[0]
                .valueAlias;
            return new Date(lastDate);
        },
    },
    methods: {
        ...DefaultApp.methods,
        async init() {
            this.loading = true;

            if (this.$el.dataset.widget) this.dataWidget = this.$el.dataset.widget;
            if (this.$el.dataset.sidebar) this.dataSidebar = this.$el.dataset.sidebar;
            if (this.$el.dataset.overruleids) this.dataOverruleIds = this.$el.dataset.overruleids.split(',');
            if (this.$el.dataset.ownid) this.ownId = this.$el.dataset.ownid;
            if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
            if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
            if (this.$el.dataset.sortkey) this.dataSortKey = this.$el.dataset.sortkey;
            if (this.$el.dataset.sortdirection) this.dataSortDirection = this.$el.dataset.sortdirection;
            if (this.$el.dataset.topiclabel) this.dataTopicLabel = this.$el.dataset.topiclabel;
            if (this.$el.dataset.datelabel) this.dataDateLabel = this.$el.dataset.datelabel;
            if (this.$el.dataset.iseducation) this.isEducation = true;

            const urlParams = new URLSearchParams(window.location.search);
            if (this.$el.dataset.topics) {
                urlParams.set(this.constants.filterTitles.topics, this.$el.dataset.topics);
            }

            let pageParam = urlParams.has(this.constants.queryParams.page) ? parseInt(urlParams.get(this.constants.queryParams.page)) : 0;
            if (pageParam) urlParams.delete(this.constants.queryParams.page);
            let filterParams = urlParams.toString() ? urlParams : null;
            if (filterParams) {
                const facetsResponse = await this.fetchData();
                this.setFacets(facetsResponse);
                this.setFacetValuesFromUrl();
            }

            if (this.dataOverruleIds.length) {
                const overruleResponse = await this.fetchData();
                if (
                    overruleResponse &&
                    overruleResponse.data &&
                    overruleResponse.data.items &&
                    overruleResponse.data.items.length
                ) {
                    overruleResponse.data.items = overruleResponse.data.items.sort(
                        (a, b) => this.dataOverruleIds.indexOf(a.id) - this.dataOverruleIds.indexOf(b.id)
                    );
                }
                this.setData(overruleResponse, true);
                this.dataOverruleIds = [];
            }

            let tempLimit = this.dataLimit;
            if (pageParam && !this.dataWidget) {
                this.page = pageParam;
                this.dataLimit = this.dataLimit + this.dataLimit * this.page;
            }

            const response = await this.fetchData();
            let replace = !this.itemsSet;
            this.setData(response, replace);
            this.dataLimit = tempLimit;

            if (this.dataSidebar && this.data.items.length < this.dataLimit) {
                const blankResponse = await this.fetchDataBlank();
                this.setData(blankResponse, false);
            }

            if (this.itemsSet) {
                this.data.items = this.removeDuplicatesById(this.data.items);
                if (this.dataWidget) this.data.items = this.data.items.slice(0, this.dataLimit);
            }

            this.loading = false;
        },
        setFacets(response) {
            if (!response || response.status != 200 || !response.data.facets) return;
            this.data.facets = response.data.facets
                .sort((a, b) => a.sortOrder - b.sortOrder)
                .map((facet) => {
                    let label = facet.alias;
                    switch (facet.alias) {
                        case this.constants.filterAliases.topics:
                            label = this.dataTopicLabel;
                            break;
                        case this.constants.filterAliases.startDateString:
                            label = this.dataDateLabel;
                            break;
                        case this.constants.filterAliases.endDateString:
                            label = this.dataDateLabel;
                            break;
                        default:
                            break;
                    }

                    return {
                        ...facet,
                        values: facet.options.filter((option) => option.selected),
                        label: label,
                    };
                });
            this.data.queryCount = response.data.queryCount;
            if (this.dataSidebar) this.setFacetValuesFromUrl();
        },
        setFacetValuesFromUrl() {
            if (!this.data.facets) return;
            const urlParams = new URLSearchParams(window.location.search);
            let filterParams = urlParams.toString() ? urlParams : null;
            if (filterParams) {
                this.data.facets.forEach((facet) => {
                    if (filterParams.has(facet.title)) {
                        let valueArray = filterParams.get(facet.title).split(',');
                        facet.values = valueArray.map((alias) =>
                            facet.options.find((option) => option.valueAlias === alias)
                        );
                    }
                });
                if (filterParams.has(this.constants.queryParams.date))
                    this.selectedDate = new Date(filterParams.get(this.constants.queryParams.date));
            }
        },
        reset() {
            this.data.facets.forEach((facet) => (facet.values = []));
            this.selectedDate = null;

            if (!this.isEducation) {
                this.skipDateFilter = true;
            }

            this.loading = true;

            if (!this.isEducation) {
                this.fetchInitialData().finally(() => {
                    this.skipDateFilter = false;
                    this.loading = false;
                });
            } else {
                this.fetchInitialData();
                this.loading = false;
            }
        },
        updateUrl() {
            if (!this.queryModel.FilterItems.length && !this.page) {
                history.pushState({}, null, window.location.pathname);
                window.dispatchEvent(new CustomEvent('update-url'));
                return;
            }
            const urlParams = new URLSearchParams();
            if (this.queryModel.FilterItems.length) {
                this.queryModel.FilterItems.forEach((filterItem) => {
                    let facet = this.data.facets.find((facet) => facet.alias === filterItem.Key);
                    if (facet) urlParams.set(facet.title, filterItem.Values.join());
                    if (this.selectedDate)
                        urlParams.set(this.constants.queryParams.date, this.selectedDate.toISOString());
                });
            }
            if (this.page) urlParams.set(this.constants.queryParams.page, this.page);
            history.pushState({}, null, window.location.pathname + '?' + urlParams.toString());
            window.dispatchEvent(new CustomEvent('update-url'));
        },
        initSwiper() {
            this.swiper = new Swiper(this.$refs.swiper, {
                ...swiperConfig,
                spaceBetween: 24,
                breakpoints: {
                    ...swiperConfig.breakpoints,
                    1408: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                    },
                },
            });
        },
    },
    updated() {
        if (this.dataWidget && !this.dataSidebar) this.initSwiper();
    },
};

export default eventApp;
